import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";

const ActiveUserPass = (props) => {
    const { t } = useTranslation();
    const { pass, i, addingToClassByInstr } = props;

    return (
        <Fragment>
            <span className="d-block">
                <p className="d-inline-block mb-1">
                    <strong>{pass.pass_name}</strong>
                </p>
                {!addingToClassByInstr && (
                    <p className="d-inline-block mb-1 float-end">
                        {t("passes.usedEntries")}:{" "}
                        <strong>
                            {pass.up_entries - pass.up_entries_left}/{pass.up_entries}
                        </strong>
                    </p>
                )}
            </span>
            <span className="d-block">
                <p className="d-inline-block mb-0">
                    {!pass.up_activation_date ? (
                        <>
                            {t("passes.activationDate")}: <span className="opacity-50">{t("lack")}</span>
                            <br />
                            {t("passes.activationTill")}: <strong>{moment(pass.up_due_date).format("DD.MM.YYYY")}</strong>
                        </>
                    ) : (
                        <>
                            {t("passes.activationDate")}:{" "}
                            <strong>
                                {moment(pass.up_activation_date).format("DD.MM.YYYY")} - {moment(pass.up_end_date).format("DD.MM.YYYY")}
                            </strong>
                        </>
                    )}
                </p>
            </span>
            {pass.up_paid === 0 && pass.up_price > 0 ? (
                <p className="mb-0 text-danger fs-6 mt-1">
                    <OverlayTrigger
                        placement="top"
                        delay={{ show: 150, hide: 100 }}
                        overlay={<Tooltip id={`paymentIsNotConfirmedTooltip${i}`}>{t("payments.paymentIsNotConfirmedTooltip")}</Tooltip>}
                    >
                        <Button variant="link text-danger text-decoration-none" className="p-0">
                            <FontAwesomeIcon icon={faExclamationCircle} className="me-2" />
                            <strong>{t("payments.paymentIsNotConfirmed")}</strong>
                        </Button>
                    </OverlayTrigger>
                </p>
            ) : pass.up_paid < pass.up_price ? (
                <p className="mb-0 text-warning fs-6 mt-1">
                    <FontAwesomeIcon icon={faExclamationCircle} className="me-2" />
                    <strong>{t("passes.notFullyPaid")}</strong>
                </p>
            ) : pass.up_paid > pass.up_price ? (
                <p className="mb-0 text-warning fs-6 mt-1">
                    <FontAwesomeIcon icon={faExclamationCircle} className="me-2" />
                    <strong>{t("passes.overPaid")}</strong>
                </p>
            ) : null}
        </Fragment>
    );
};

export default ActiveUserPass;
